export function toVariant(url, variant = "thumb") {
  if (!url) return url;
  const cloudflare = url.match(/^(https?:\/\/imagedelivery\.net\/[^/]+\/[^/?#]+)(?:\/[^/?#]*)?([?#].*)?$/i);
  if (cloudflare) {
    return `${cloudflare[1]}/${variant}${cloudflare[2] || ""}`;
  }
  if (/\/(public|hq|thumb)(?=[?#]|$)/.test(url)) {
    return url.replace(/\/(public|hq|thumb)(?=[?#]|$)/, `/${variant}`);
  }
  return url;
}

export function thumbSrc(url) {
  return toVariant(url, "thumb");
}

export function publicSrc(url) {
  return toVariant(url, "public");
}

export function hqSrc(url) {
  return toVariant(url, "hq");
}
